<template>
<!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" class="checkSVG" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 539.5 448.3" style="enable-background:new 0 0 539.5 448.3;" xml:space="preserve">
<title>Check Mark</title>
<g>
	<g id="Layer_1-2">
		<g>
			<path class="st0" d="M499.8,5.5l23.5,14c2.6,1.6,5,3.6,7,5.9c7,8.4,9.8,21.1,7.6,33.9l-23.5-14c2.2-12.8-0.6-25.4-7.5-33.9
				C504.8,9.1,502.5,7.1,499.8,5.5z"/>
			<path class="st1" d="M476.5,1.4c8.8-1.2,17,0.4,23.3,4.1l23.5,14c-6.3-3.8-14.5-5.4-23.3-4.1L476.5,1.4z"/>
			<path class="st0" d="M135.3,441.8l-23.5-14c8.4,4.8,18.2,6.6,27.7,5.2c9.3-1.3,18-5.3,25.1-11.6c13.8-12.5,25.7-24.3,31.6-30.2
				c5.7-5.7,19.1-19.3,35-36.8c23-24.9,46.5-52.9,69.2-80c21.2-25.3,43.1-51.5,64.7-75.1c40.7-45.6,85.2-87.5,133.1-125.4
				c8.3-6.6,14.2-17,16.3-28.6l23.5,14c-2,11.5-8,21.9-16.3,28.5c-47.9,37.8-92.5,79.8-133.2,125.4c-21.5,23.6-43.4,49.8-64.7,75.1
				c-22.7,27.1-46.1,55.1-69.2,80c-15.9,17.5-29.3,31.1-35,36.8c-5.9,5.9-17.8,17.7-31.6,30.2c-7,6.3-15.7,10.3-25,11.6
				C153.5,448.3,143.7,446.5,135.3,441.8z"/>
			<path class="st1" d="M447.4,15.6c9.6-8.5,19.8-12.9,29.1-14.3l23.5,14c-9.3,1.3-19.5,5.8-29.1,14.3
				c-47.5,40.5-92,84.4-133.2,131.2c-20.7,23.2-41.8,48.6-62.2,73.2c-23.5,28.3-47.8,57.5-71.6,83.6c-9,10-20.7,16.5-32.3,18.2
				c-0.7,0.1-1.3,0.2-2,0.2c-6.6,0.7-13.3-0.5-19.3-3.4l-23.5-14c6,2.9,12.7,4.1,19.4,3.5c0.7-0.1,1.3-0.1,2-0.2
				c11.6-1.6,23.3-8.2,32.3-18.2c23.8-26,48.1-55.3,71.6-83.6c20.4-24.6,41.5-50,62.2-73.2C355.4,100,399.9,56.2,447.4,15.6z"/>
			<path class="st0" d="M500.1,4.4l23.5,14c-5.9-3.5-13.1-5-21.1-4.2c-0.6,0.1-1.2,0.1-1.8,0.2c-10.4,1.5-21.4,6.7-30.3,14.5
				c-47.5,40.5-92,84.4-133.3,131.3c-20.7,23.2-41.9,48.6-62.3,73.2c-23.5,28.3-47.8,57.5-71.6,83.6l-23.5-14
				c23.8-26,48.1-55.2,71.6-83.5c20.4-24.6,41.5-50,62.3-73.2C354.8,99.4,399.4,55.5,446.9,15c8.9-7.8,19.9-13,30.3-14.5
				c0.6-0.1,1.2-0.2,1.8-0.2C487-0.6,494.2,0.9,500.1,4.4z"/>
			<path class="st0" d="M148.7,330.6l-23.5-14c6.3,3.6,13.6,5.2,20.8,4.4c0.6-0.1,1.3-0.1,1.9-0.2c11.4-1.6,22.8-8,31.7-17.8
				l23.5,14c-8.9,9.8-20.3,16.2-31.7,17.8c-0.6,0.1-1.3,0.2-1.9,0.2C162.3,335.8,155,334.3,148.7,330.6z"/>
			<path class="st1" d="M124.7,317.5c0.6,0.4,1.3,0.8,2,1.1l23.5,14c-0.7-0.3-1.3-0.7-2-1.1L124.7,317.5z"/>
			<path class="st0" d="M148.2,331.5l-23.5-14c-2.7-1.6-5.1-3.6-7.2-5.9c-15-16.2-29.6-33.4-43.5-51.2c-3.6-4.6-8.1-8.5-13.1-11.4
				l23.5,14c5,3,9.5,6.9,13.1,11.5c13.9,17.7,28.5,34.9,43.5,51.2C143.1,327.9,145.5,329.9,148.2,331.5z"/>
			<path class="st1" d="M60.6,248.9l0.3,0.2l23.5,14l-0.3-0.2L60.6,248.9z"/>
			<path class="st1" d="M60.6,248.9l3.8,2.3l10.6,6.3l2.7,1.6l1.3,0.8l1.3,0.8l1.3,0.8l1.2,0.7c0.4,0.2,0.8,0.7,1.2,0.7
				c-8.6-5.1-18.7-7.2-28.6-5.9c-6,0.8-11.8,3.1-16.7,6.6c-1.5,1.1-2.9,2.2-4.2,3.6L11,253c1.3-1.3,2.7-2.5,4.2-3.6
				c5-3.5,10.7-5.8,16.8-6.6C41.9,241.7,52,243.8,60.6,248.9z"/>
			<path class="st1" d="M11,253.1l23.5,14c-4.4,4.6-7.5,10.3-8.9,16.5c-3.3,13.6-0.1,29.6,8.7,42.9C61.6,366.7,91.7,401.9,129,437
				c1.9,1.8,4,3.4,6.3,4.7l-23.5-14c-2.3-1.3-4.4-2.9-6.3-4.7c-37.3-35.1-67.4-70.3-94.6-110.6c-8.8-13.2-12.1-29.2-8.7-42.9
				C3.6,263.4,6.6,257.7,11,253.1z"/>
			<path class="st0" d="M531,24.7c7.1,8.6,10,21.6,7.7,34.6c-2.1,11.8-8.1,22.5-16.7,29.3c-47.9,37.8-92.4,79.7-133,125.2
				c-21.5,23.6-43.4,49.8-64.6,75.1C301.7,316,278.2,344,255.2,369c-15.9,17.5-29.3,31.1-34.3,36.1c-6.6,6.6-18.5,18.4-32.3,30.9
				c-7.2,6.4-16.1,10.5-25.6,11.8c-12.6,1.8-25.5-1.5-34.6-10C91,402.6,60.9,367.4,33.6,327c-8.9-13.4-12.2-29.7-8.8-43.6
				c2.2-8.8,6.8-16,13.5-20.7c5.1-3.6,11-5.9,17.1-6.7c15.3-2.1,32,4.3,42.7,17.8c13.9,17.7,28.5,34.9,43.5,51.1
				c7,7.5,16.9,11.1,27.9,10.1c0.6-0.1,1.3-0.1,1.9-0.2c11.4-1.6,22.8-8,31.7-17.8c23.8-26,48.1-55.2,71.6-83.5
				c20.4-24.6,41.5-50,62.3-73.2c41.3-46.9,85.8-90.8,133.3-131.3c8.9-7.8,19.9-13.1,30.3-14.5c0.6-0.1,1.2-0.2,1.8-0.2
				C514.2,13,524.4,16.8,531,24.7z M537.9,59.3c2.2-12.8-0.6-25.4-7.6-33.9c-6.5-7.8-17.7-11.8-30.3-10c-9.3,1.3-19.5,5.8-29.1,14.3
				c-47.5,40.5-92,84.4-133.2,131.2c-20.7,23.1-41.8,48.6-62.2,73.1c-23.5,28.3-47.8,57.5-71.6,83.6c-9,10-20.7,16.5-32.3,18.2
				c-0.7,0.1-1.3,0.2-2,0.2c-11.3,1-21.4-2.6-28.5-10.3c-15-16.2-29.6-33.4-43.5-51.2c-10.6-13.4-27.1-19.7-42-17.6
				c-6,0.8-11.8,3.1-16.7,6.6c-6.4,4.5-11,11.5-13,20c-3.3,13.6-0.1,29.6,8.7,42.9C61.6,366.7,91.7,401.9,129,437
				c8.9,8.4,21.6,11.6,34,9.9c9.3-1.3,18-5.4,25-11.6c13.8-12.5,25.7-24.3,31.6-30.2c5.7-5.7,19.1-19.3,35-36.8
				c23-24.9,46.5-52.9,69.2-80c21.2-25.4,43.2-51.5,64.7-75.2c40.7-45.6,85.2-87.5,133.2-125.4C529.9,81.2,535.9,70.8,537.9,59.3"/>
			<path class="st1" d="M500,15.4c12.6-1.8,23.8,2.2,30.3,10c7,8.4,9.8,21.1,7.6,33.9c-2,11.5-8,21.9-16.3,28.6
				c-48,37.9-92.5,79.8-133.2,125.4c-21.5,23.6-43.4,49.8-64.7,75.1c-22.7,27.1-46.1,55.1-69.2,80c-15.9,17.5-29.3,31.1-34.3,36.1
				c-6.6,6.6-18.5,18.4-32.3,30.9c-7,6.3-15.7,10.3-25,11.6c-12.4,1.7-25.1-1.5-34-9.9c-37.4-35.1-67.5-70.3-94.7-110.6
				c-8.8-13.2-12-29.2-8.7-42.9c2.1-8.6,6.6-15.5,13-20c5-3.5,10.7-5.8,16.7-6.6c15-2.1,31.5,4.2,42,17.6
				c13.9,17.7,28.6,34.9,43.6,51.1c7.1,7.7,17.2,11.4,28.5,10.3c0.7-0.1,1.3-0.1,2-0.2c11.6-1.6,23.3-8.2,32.3-18.2
				c23.8-26,48.1-55.3,71.6-83.6c20.4-24.6,41.5-50,62.2-73.2c41.2-46.8,85.7-90.7,133.2-131.2C480.5,21.1,490.6,16.7,500,15.4z"/>
			<path class="st0" d="M134.8,442.6l-23.5-14c-2.3-1.4-4.4-3-6.4-4.8c-37.4-35.2-67.5-70.4-94.8-110.8
				c-8.9-13.4-12.2-29.7-8.8-43.6c2.2-8.8,6.8-16,13.5-20.7c5.1-3.6,10.9-5.9,17.1-6.8c10.3-1.3,20.7,0.9,29.5,6.2l23.5,14
				c-8.8-5.3-19.2-7.5-29.5-6.2c-6.2,0.8-12.1,3.2-17.1,6.8c-6.7,4.7-11.3,11.9-13.5,20.7c-3.4,13.9-0.1,30.2,8.8,43.6
				c27.2,40.3,57.4,75.5,94.8,110.7C130.3,439.6,132.5,441.2,134.8,442.6z"/>
		</g>
	</g>
</g>
</svg>

</template>

<script>

export default {
  name: 'layout-check',
}
</script>

<style lang="scss">
  .checkSVG {width: 20px;}
	.st0{enable-background:new    ;fill:$brandGreen;}
	.st1{fill:$brandLightGreen;}

</style>
